import UiModal from '../../../../js/components/UiModal/UiModal'
import Form from '../../../../js/Form/Form'
import { defaultRules } from '../../../../js/Form/default-rules'
import { ClassName } from '../../../../js/Form/const'
import { createElement, render, RenderPosition } from '../../../../js/utils/render'

const INPUT_TYPE = {
  USERNAME: 'username',
  PHONE: 'phone'
}

const NOTICE_TEXT = {
  USERNAME: 'Оставьте, пожалуйста, свой ник в&nbsp;формате @username',
  PHONE: 'Проверьте корректность данных перед отправкой'
}

const SWITCH_BUTTON_TEXT = {
  PHONE: 'Нет username? Укажите номер телефона',
  USERNAME: 'Указать @username'
}

const getInputSwitchButtonTemplate = () => (
  `<button
    type="button"
    class="messenger-popup__input-switch-button"
  >
    ${SWITCH_BUTTON_TEXT.PHONE}
  </button>`
)

class MessengerPopup extends UiModal {
  /**
   * @param {HTMLElement} template
   * @param {Object} options
   * @param {String} options.blockName
   */
  constructor(template, options = {}) {
    super(template, {
      wrapperClass: 'messenger-popup',
      outerScroll: true,
      isIndent: false,
      isCloseButton: false,
      disableOutsideAndEscClose: true,
      blockTriggerName: options.blockName || 'Блок без названия',
    })

    this._content = template
    this._form = null
    this._inputSwitchButtonElement = null

    this._radioButtonsWrapper = this._content.querySelector('.messenger-popup__buttons')
    this._firstRadioButton = this._content.querySelector('.messenger-radio-button__input')
    this._notice = this._content.querySelector('.messenger-popup__notice')
    this._phoneInput = this._content.querySelector('.messenger-popup__input--channel-phone')
    this._usernameInput = this._content.querySelector('.messenger-popup__input--username')
    this._submitButton = this._content.querySelector('.messenger-popup__form-button')

    this._changeChannelHandler = this._changeChannelHandler.bind(this)
    this._inputSwitchHandler = this._inputSwitchHandler.bind(this)
    this._formSuccessHandler = this._formSuccessHandler.bind(this)

    this._inputType = INPUT_TYPE.USERNAME
    this._isTelegramSelected = true
  }

  beforeMounted() {
    this._form = this._content.querySelector('.form')
    this._initForm()

    this._radioButtonsWrapper.addEventListener('change', this._changeChannelHandler)
  }

  beforeUnmounted() {
    this._radioButtonsWrapper.removeEventListener('change', this._changeChannelHandler)
    this._inputSwitchButtonElement?.removeEventListener('click', this._inputSwitchHandler)
  }

  _initForm() {
    this._form.addEventListener('after-form-success', this._formSuccessHandler)
    this._firstRadioButton.checked = true

    this._renderInputSwitchButton()

    new Form({
      form: this._form,
      rules: {
        channel_phone: defaultRules.phone,
        telegram_username: {
          required: true,
          min: 5,
          max: 32,
          telegramUsername: true
        }
      },
      blockName: this.blockTriggerName
    }).init()

    this._updateInputsVisibility()
  }

  _switchInputType(field, isVisible) {
    const input = field.querySelector('input')

    field.style.display = isVisible ? 'block' : 'none'
    input.disabled = !isVisible

    if (!isVisible) {
      input.value = ''
      field.classList.remove(ClassName.FIELD_ERROR, ClassName.ACTIVE)
    }
  }

  _renderInputSwitchButton() {
    if (this._inputSwitchButtonElement) {
      return
    }

    this._inputSwitchButtonElement = createElement(
      getInputSwitchButtonTemplate()
    )

    this._inputSwitchButtonElement.addEventListener('click', this._inputSwitchHandler)

    render(this._submitButton, this._inputSwitchButtonElement, RenderPosition.BEFOREBEGIN)

    this._changeSwitchButtonText()
  }

  _destroyInputSwitchButton() {
    if (this._inputSwitchButtonElement) {
      this._inputSwitchButtonElement.removeEventListener('click', this._inputSwitchHandler)
      this._inputSwitchButtonElement.remove()
      this._inputSwitchButtonElement = null
    }
  }

  _updateInputsVisibility() {
    const isTelegram = this._isTelegramSelected
    const isUsername = this._inputType === INPUT_TYPE.USERNAME

    if (isTelegram) {
      this._switchInputType(this._usernameInput, isUsername)
      this._switchInputType(this._phoneInput, !isUsername)
    } else {
      this._switchInputType(this._usernameInput, false)
      this._switchInputType(this._phoneInput, true)
    }
  }

  _changeNoticeText() {
    this._notice.innerHTML = this._inputType === INPUT_TYPE.USERNAME
      ? NOTICE_TEXT.USERNAME
      : NOTICE_TEXT.PHONE
  }

  _changeSwitchButtonText() {
    this._inputSwitchButtonElement.textContent = this._inputType === INPUT_TYPE.USERNAME
      ? SWITCH_BUTTON_TEXT.PHONE
      : SWITCH_BUTTON_TEXT.USERNAME
  }

  _inputSwitchHandler() {
    this._inputType = this._inputType === INPUT_TYPE.PHONE ? INPUT_TYPE.USERNAME : INPUT_TYPE.PHONE

    this._updateInputsVisibility()
    this._renderInputSwitchButton()

    this._changeNoticeText()
    this._changeSwitchButtonText()
  }

  _changeChannelHandler(evt) {
    const target = evt.target

    if (!target) {
      return
    }

    this._isTelegramSelected = target.value.toLowerCase() === 'telegram'

    if (this._isTelegramSelected) {
      this._inputType = INPUT_TYPE.USERNAME
      this._renderInputSwitchButton()
    } else if (!this._isTelegramSelected || this._inputType !== INPUT_TYPE.PHONE) {
      this._destroyInputSwitchButton()
      this._inputType = INPUT_TYPE.PHONE
    }

    this._updateInputsVisibility()
    this._changeNoticeText()
  }

  _formSuccessHandler = () => {
    const isSafari = /^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent)
    const isIos = (/iPhone|iPad|iPod/.test(navigator.userAgent))

    let redirectUrl = 'https://t.me/lerna_cis_bot?start=n_148552__c_10053'

    // eslint-disable-next-line no-undef
    if (landingInfo?.countrySlug === 'kz') {
      redirectUrl = 'https://t.me/kz_lerna_bot?start=n_151963__c_10052'
    }

    // такая реализация по причине блокировки всплывающих окон в safari MacOS и iOS
    if (!(isSafari && isIos)) {
      const link = document.createElement('a')
      link.href = redirectUrl
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } else {
      setTimeout(() => {
        window.location.href = redirectUrl
      }, 1000)
    }

    this.close()
  }
}

export const showMessengerPopup = (options) => {
  const template = document.querySelector('#messenger-popup')?.content
    .cloneNode(true).querySelector('.messenger-popup__wrapper')

  if (!template) {
    const err = new Error(`[Messenger Popup]: шаблон с id=messenger-popup отсутствует`)
    console.error(err)
    window.Sentry?.captureException(err)
    return
  }

  const messengerPopup = new MessengerPopup(template, options)
  messengerPopup.init()

  return messengerPopup
}
